import PopupLogout from "components/popup-logout";
import React, { useEffect, useState } from "react";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import routes from "routes";
const TheHeader = () => {
  const [nav, setNav] = useState(false);
  const [active, setActive] = useState(null);
  const [namePage, setNamePage] = useState("Home");
  const navigate = useNavigate();
  const handleNav = () => {
    setNav(true);
    document.body.classList.add("modal-open");
  };
  const handleCloseNav = (e) => {
    setNav(false);
    document.body.classList.remove("modal-open");
  };

  const handleNavigate = (e) => {
    navigate(e);
    handleCloseNav();
  };
  useEffect(() => {
    if (window.location.pathname) {
      handleNavigate(window.location.pathname);
      setActive(window.location.pathname);
      console.log("window.location.pathname", window.location.pathname);
      if (window.location.pathname === "/") {
        document.title = "Gửi Lời Rạng Rỡ, Kết Năm Rạng Ngời";
      } else {
        document.title =
          "Gửi Lời Rạng Rỡ, Kết Năm Rạng Ngời" +
          `${namePage && " - " + namePage}`;
      }
    } else {
      handleNavigate("/");
      setActive("/");
      document.title = "Gửi Lời Rạng Rỡ, Kết Năm Rạng Ngời";
    }
  }, [window.location.pathname]);

  const getTitleHead = (e) => {
    var x = document.createElement("TITLE");
    var t = document.createTextNode("HTML DOM Objects");
    x.appendChild(t);
    document.head.appendChild(x);

    document.getElementById("demo").innerHTML = "You have ";
  };

  const location = useLocation();

  return (
    <>
      {location.pathname !== "/thongtinnguoidung" &&
        location.pathname !== "/game" && (
          <>
            <header>
              <a
                onClick={() => {
                  setActive("/");
                  handleNavigate("/");
                }}
                className="logo"
              >
                <img src="assets/img/logoBrand.png" />
              </a>
              {/* <nav id="sidr-main" className={`${nav ? "right" : ""}`}>
            <div className="nav-inner">
              <span
                className="icon-close d-none"
                onClick={handleCloseNav}
              ></span>
              <a
                onClick={() => {
                  setActive("/");
                  handleNavigate("/");
                }}
                className="logo-nav d-none"
              >
                <img src="assets/img/logoSL.png" />
              </a>
              <ul>
                {routes.map((link, index) => {
                  return (
                    <>
                      {link.path !== "/thongtinnguoidung" && (
                        <>
                          <li key={index} className="nav-item">
                            <a
                              href={`#${link.path}`}
                              className={`nav-link ${
                                active == link.path && "active"
                              }`}
                              onClick={() => {
                                setActive(link.path);
                                setNamePage(link.name);
                                handleNavigate(link.path);
                              }}
                            >
                              {link.name}
                            </a>
                          </li>
                        </>
                      )}
                    </>
                  );
                })}
              </ul>
            </div>
            <img
              className="nav-footer d-none"
              onClick={handleCloseNav}
              src="assets/img/nav-footer.png"
              alt=""
            />
          </nav> */}
              {/* <span className="icon-nav" onClick={handleNav}></span> */}

              {/* <span
                className="icon-home"
                onClick={() => {
                  setActive("/");
                  handleNavigate("/");
                }}
              ></span> */}
            </header>
            {nav && (
              <PopupLogout
                content="Đăng xuất"
                handleCloseNav={handleCloseNav}
              />
            )}
          </>
        )}
      {window.location.pathname === "/thongtinnguoidung" && (
        <div className="header">THÔNG TIN NGƯỜI TRÚNG THƯỞNG</div>
      )}
      {window.location.pathname === "/game" && ""}
    </>
  );
};

export default TheHeader;
